import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  type OnDestroy,
  type OnInit,
  type TemplateRef,
  ViewChild,
} from '@angular/core';
import { type NavConfig, NavigationService } from './navigation.service';

@Component({
  selector: 'rcp-nav-content',
  template: `
    <ng-template #topSingle>
      <ng-content select="[slot=top-single]"></ng-content>
    </ng-template>
    <ng-template #sideTopNav>
      <ng-content select="[slot=side-top]"></ng-content>
    </ng-template>
    <ng-template #topLeftNav>
      <ng-content select="[slot=top-left]"></ng-content>
    </ng-template>
    <ng-template #topRightNav>
      <ng-content select="[slot=top-right]"></ng-content>
    </ng-template>
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavContentComponent implements OnInit, OnDestroy {
  navigationService = inject(NavigationService);

  // the rootpath for this context
  // used for navigating back to this context
  @Input() rootPath: string[];
  @Input() navIndex = 0;
  @Input() showLogoutInSideNav: boolean;
  @Input() onlyTop = false;
  @Input() forMobile = false;

  @ViewChild('topSingle') topSingleTemplate: TemplateRef<any>;
  @ViewChild('sideTopNav') sideNavTemplate: TemplateRef<any>;
  @ViewChild('topRightNav') topRightNavTemplate: TemplateRef<any>;
  @ViewChild('topLeftNav') topLeftNavTemplate: TemplateRef<any>;

  private navConfig: NavConfig;

  ngOnInit() {
    this.navConfig = {
      rootPath: this.rootPath,
      showLogoutInSideNav: this.showLogoutInSideNav,
    };

    this.navigationService.setNavConfig(this.navIndex, this.navConfig);

    // wait a tick for ng-content to be projected
    setTimeout(() => {
      this.setTemplates();
    });
  }

  private setTemplates() {
    if (!this.onlyTop) {
      this.navConfig.sideNavTemplate = this.sideNavTemplate;
    }
    this.navConfig.topRightNavTemplate = this.topRightNavTemplate;
    this.navConfig.topLeftNavTemplate = this.topLeftNavTemplate;

    // @ts-expect-error TS2322 type not assignable
    this.navConfig.topSingleTemplate = this.forMobile ? this.topSingleTemplate : null;
  }

  ngOnDestroy() {
    this.navigationService.unsetNavConfig(this.navConfig);
  }
}
